export function assignment<T extends Record<string, unknown>>(
  result: T,
  ...sources: Record<string, unknown>[]
): T {
  const stack = [...sources]
  let item: Record<string, unknown>
  let key: string

  while (stack.length) {
    item = stack.shift()!
    for (key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
        if (
          typeof (result as Record<string, unknown>)[key] === 'object' &&
          (result as Record<string, unknown>)[key] &&
          Object.prototype.toString.call((result as Record<string, unknown>)[key]) !==
            '[object Array]'
        ) {
          if (typeof item[key] === 'object' && item[key] !== null) {
            ;(result as Record<string, unknown>)[key] = assignment(
              {},
              (result as Record<string, unknown>)[key] as Record<string, unknown>,
              item[key] as Record<string, unknown>,
            )
          } else {
            ;(result as Record<string, unknown>)[key] = item[key]
          }
        } else {
          ;(result as Record<string, unknown>)[key] = item[key]
        }
      }
    }
  }
  return result
}
